import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import simplebar from "simplebar-vue";
import BaseMixer from "@/router/views/BaseMixer";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { AssetReportModel } from "@/store/models/asset/assetReportDTO";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { toaster } from "@/utilities/toaster";
Component.registerHooks(["metaInfo"]);
let AssetScrappedDisposedReport = /** @class */ (() => {
    let AssetScrappedDisposedReport = class AssetScrappedDisposedReport extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Asset Disposal Report";
            this.pageIsLoading = false;
            this.isPageLoading = false;
            this.reportFilter = new AssetReportModel();
            this.showTable = false;
            this.showText = true;
            this.items = [
                { text: "Home", to: "/dashBoard" },
                { text: "Reports" },
                { text: "Asset Disposal Report", active: true },
            ];
        }
        get reportDetails() {
            return AssetMasterModule.assetScrappedDisposedReportDetails;
        }
        getReportDetails() {
            this.validate("validateObserver").then((res) => {
                if (res) {
                    if (this.reportFilter.startDate > this.reportFilter.endDate) {
                        toaster.ShowError("Start date should not be greater than end date.");
                        return;
                    }
                    const maxEndDate = new Date(this.reportFilter.startDate);
                    maxEndDate.setFullYear(maxEndDate.getFullYear() + 1);
                    if (this.reportFilter.endDate > maxEndDate) {
                        toaster.ShowError("Date range cannot exceed 1 year.");
                        return;
                    }
                    this.pageIsLoading = true;
                    this.showText = false;
                    this.reportFilter.startDateAsString = this.dateFormattedString(this.reportFilter.startDate);
                    this.reportFilter.endDateAsString = this.dateFormattedString(this.reportFilter.endDate);
                    AssetMasterModule.GetAssetScrappedDisposedReport(this.reportFilter).then((res) => {
                        if (res) {
                            this.showTable = true;
                            this.pageIsLoading = false;
                        }
                    });
                }
            });
        }
        clearFilter() {
            this.reportFilter.startDate = null;
            this.reportFilter.endDate = null;
            this.showTable = false;
            this.showText = true;
        }
        exportAsExcel() {
            this.isPageLoading = true;
            this.validate("validateObserver").then((res) => {
                if (res) {
                    if (this.reportFilter.startDate > this.reportFilter.endDate) {
                        toaster.ShowError("Start date should not be greater than end date.");
                        this.isPageLoading = false;
                        return;
                    }
                    const maxEndDate = new Date(this.reportFilter.startDate);
                    maxEndDate.setFullYear(maxEndDate.getFullYear() + 1);
                    if (this.reportFilter.endDate > maxEndDate) {
                        toaster.ShowError("Date range cannot exceed 1 year.");
                        this.isPageLoading = false;
                        return;
                    }
                    this.reportFilter.startDateAsString = this.dateFormattedString(this.reportFilter.startDate);
                    this.reportFilter.endDateAsString = this.dateFormattedString(this.reportFilter.endDate);
                    AssetMasterModule.GetAssetScrappedDisposedReportAsExcel(this.reportFilter).then((res) => {
                        if (res) {
                            const blob = new Blob([res], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            document.body.appendChild(link);
                            link.download = `AssetDisposalReport.xlsx`;
                            link.click();
                            this.isPageLoading = false;
                        }
                    });
                }
            });
        }
        disabledEndDate(date) {
            if (!this.reportFilter.startDate)
                return false;
            const maxDate = new Date(this.reportFilter.startDate);
            maxDate.setFullYear(maxDate.getFullYear() + 1);
            return date > maxDate;
        }
        created() { }
    };
    AssetScrappedDisposedReport = __decorate([
        Component({
            name: "AssetScrappedDisposedReport",
            components: {
                Loader,
                SectionLoader,
                Layout,
                PageHeader,
                simplebar,
            },
        })
    ], AssetScrappedDisposedReport);
    return AssetScrappedDisposedReport;
})();
export default AssetScrappedDisposedReport;
